<template>
	<div v-loading="!isConnected && (safeUserInfo.isCamera || safeUserInfo.isShareScreen)" class="remote-video" ref="box" @click="resumePlayback">
		<div class="avatar" :style="{ 'height': height, 'width': width }" v-show="!isShowVideo">
			<head-image class="head-image" :url="safeUserInfo.headImage" :name="displayName" :size="64">
			</head-image>
		</div>
		<div v-if="playbackBlocked" class="playback-hint">点击画面播放声音</div>
		<div class="info-bar">
			<div v-show="safeUserInfo.isMicroPhone" class="icon iconfont icon-microphone-on"></div>
			<div v-show="!safeUserInfo.isMicroPhone" class="icon iconfont icon-microphone-off"></div>
			<div class="name">{{ displayName }}</div>
		</div>
		<video v-show="isShowVideo" class="video" :class="safeUserInfo.isShareScreen ? 'contain' : ''" ref="video"></video>
	</div>
</template>

<script>
import HeadImage from '@/components/common/HeadImage';

export default {
    name: 'remoteVideo',
    components: { HeadImage },
    props: { width: Number, height: Number, userInfo: Object },
    data() { return { stream: null, isMuted: false, playbackBlocked: false }; },
    methods: {
        open(stream) {
            if (stream === this.stream && this.$refs.video?.srcObject === stream) return;
            this.stream = stream;
            this.playbackBlocked = false;
            this.$nextTick(() => {
                const video = this.$refs.video;
                if (!video || stream !== this.stream) return;
                video.srcObject = stream;
                video.muted = this.isMuted;
                if (stream) video.play().catch(() => { if (stream === this.stream) this.playbackBlocked = true; });
            });
        },
        setMute(value) {
            this.isMuted = value;
            if (this.$refs.video) this.$refs.video.muted = value;
        },
        resumePlayback() {
            if (this.stream && this.$refs.video) {
                this.$refs.video.play().then(() => { this.playbackBlocked = false; }).catch(() => {});
            }
        }
    },
    computed: {
        safeUserInfo() { return this.userInfo || {}; },
        displayName() { return this.safeUserInfo.nickName || this.safeUserInfo.userName || '当前成员'; },
        isConnected() { return Boolean(this.stream); },
        isShowVideo() {
            const hasVideoTrack = Boolean(this.stream && this.stream.getVideoTracks
                && this.stream.getVideoTracks().some(track => track && track.readyState !== 'ended'));
            return this.isConnected
                && (this.safeUserInfo.isCamera === true || this.safeUserInfo.isShareScreen === true)
                && hasVideoTrack;
        }
    },
    beforeDestroy() { if (this.$refs.video) this.$refs.video.srcObject = null; }
}
</script>

<style lang="scss" scoped>
.playback-hint { position: absolute; top: 8px; left: 8px; z-index: 2; color: white; background: #333a; padding: 6px; }
.remote-video {
	position: relative;
	width: 100%;
	height: 100%;
	background: var(--im-chat-bg, var(--im-background));
	cursor: pointer;
	overflow: hidden;
	border: 2px solid var(--im-border-light);
	box-sizing: border-box;

	.avatar {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 100%;
	}

	.info-bar {
		position: absolute;
		bottom: 10px;
		left: 10px;
		overflow: hidden;
		color: var(--im-text-color-white);
		font-size: var(--im-font-size);
		display: flex;
		align-items: center;
		z-index: 2;
		background-color: rgba(var(--im-black-rgb), 0.4);
		padding: 2px 6px;
		border-radius: 4px;

		.icon {
			font-size: var(--im-font-size);
			margin-right: 2px;
		}
	}

	.video {
		position: relative;
		width: 100%;
		height: 100%;
		object-fit: cover;
		background: var(--rtc-group-surface, var(--im-chat-bg, var(--im-background)));

		&.contain {
			object-fit: contain;
		}
	}
}
</style>
